module.exports = __webpack_public_path__ + "img/PL08797.8ba50b46.png";